import { fieldLabelString } from 'components/core/dynamic-form/fields/FieldLabel'
import { RenderFieldProps, UnknownField } from 'components/core/dynamic-form/fields/RenderField'
import { C1FileInput, PLACEHOLDER_FILE_UPLOADED } from 'components/core/RHKFormComponents/C1FileInput'
import { FC, useCallback } from 'react'
import { useIntl } from 'react-intl'

export const RenderFileField: FC<RenderFieldProps> = ({ field, cField, errors, disabled }) => {
    const intl = useIntl()
    const hasExistingFile = cField.value === PLACEHOLDER_FILE_UPLOADED

    // Wrap onChange so that clearing a previously uploaded file sets '' (empty string)
    // instead of undefined. This ensures submission sends an empty stringValue to the
    // backend, which deletes the stored value. For new file selections, pass through directly.
    const handleChange = useCallback((file: File | undefined): void => {
        if (file === undefined && hasExistingFile) {
            cField.onChange('')
        } else {
            cField.onChange(file)
        }
    }, [cField, hasExistingFile])

    if (field.type.oneofKind !== 'fileField') return <UnknownField field={field} />

    const fileField = field.type.fileField
    // Only pass File objects as the value — the sentinel string is handled via hasExistingFile
    const fileValue = cField.value instanceof File ? cField.value : undefined

    return (
        <C1FileInput
            label={fieldLabelString(field.displayName, field.required, intl)}
            name={field.name}
            value={fileValue}
            onChange={handleChange}
            onBlur={cField.onBlur}
            error={!!errors[field.name]}
            helperText={(errors[field.name]?.message as string) || field.description}
            disabled={disabled}
            acceptedFileTypes={fileField.acceptedFileTypes}
            hasExistingFile={hasExistingFile}
        />
    )
}
